var cov_2ijil7wgth = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/index.ts",
      hash = "cb55293ca14190e4d4768853278a6b32e114ce37",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DataList/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 37
        },
        end: {
          line: 8,
          column: 94
        }
      },
      "1": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 17,
          column: 8
        }
      },
      "2": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 24
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { compose } from '../utils/func';
import Datum from '../Datum';
import DList from './List';
import BaseItem from './BaseItem';
import Pagination from './Pagination';
var bindKeys = (cov_2ijil7wgth.s[0]++, ['disabled', 'limit', 'format', 'prediction', 'distinct']);
var List = (cov_2ijil7wgth.s[1]++, compose(Datum.hoc({
  bindProps: bindKeys,
  ignoreUndefined: true,
  setValueType: null,
  pure: false
}), Pagination)(DList));
cov_2ijil7wgth.s[2]++;
List.BaseItem = BaseItem;
export default List;